const CellPhoneIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.845 5.50244H11.155C10.2631 5.50244 9.54004 6.2255 9.54004 7.11744V24.8824C9.54004 25.7744 10.2631 26.4974 11.155 26.4974H20.845C21.737 26.4974 22.46 25.7744 22.46 24.8824V7.11744C22.46 6.2255 21.737 5.50244 20.845 5.50244Z"
      stroke="#041C1B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.54004 8.73254H22.46"
      stroke="#041C1B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.54004 23.2675H22.46"
      stroke="#041C1B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export { CellPhoneIcon };
